import React from 'react';
import { useNavigate } from "react-router-dom";
import { SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { Grid, GridColumn as Column, GridColumnMenuWrapper } from "@progress/kendo-react-grid";
import dateFormats from "../../Data/dateFormats.json";
import historyGridColumns from "../../Data/historyGridColumns.json";
import { LoadingPanel } from '../LoadingPanel';
import { TextCell } from './Cell/TextCell';
import { CustomColumnMenu } from "../CustomColumnMenu";
import { ColumnSelectButton } from "../ColumnSelectButton";
import { ColumnManager } from "../../services/columnManager";

export function HistoryGrid(props) {
    const navigate = useNavigate();

    const { columnResize, columnReorder, onColumnsSubmit, defaultSettings } = ColumnManager(historyGridColumns, "historyGridSettings");
    const [stateColumns, setStateColumns] = React.useState(defaultSettings);

    const [dateFormat, setdateFormat] = React.useState("{0:dd/MM/yyyy hh:mm a}");
    const [dateFormatFilter, setdateFormatFilter] = React.useState("dd/MM/yyyy hh:mm a");
    const [shortDateFormatFilter, setshortDateFormatFilter] = React.useState("dd/MM/yyyy");
    const handleColumnSubmit = (columns) => {
        let newcolumns = onColumnsSubmit(columns);
        setStateColumns(newcolumns);
    }

    const linkClick = (materialId) => { navigate("/material/" + materialId + (props.searchArchive ? "?searchArchive=true" : "")); }

    React.useEffect(() => {
        if (props.dateFormatId != null) {
            let format = dateFormats.find(x => x.value === props.dateFormatId);
            if (format != null) {
                setdateFormat("{0:" + format.text + " hh:mm a}");
                setdateFormatFilter(format.text + " hh:mm a");
                setshortDateFormatFilter(format.text);
            }
        }
    }, [props.dateFormatId]);

    return (
        <div style={{ height: 'calc(100vh - 375px)', minHeight: '300px' }}>
            <ColumnSelectButton open={props.showColumnSelect} setopen={props.setshowColumnSelect} onColumnsSubmit={handleColumnSubmit} originalColumns={historyGridColumns} columns={stateColumns} setStateColumns={setStateColumns} localizations={props.localizations} />
            <Grid
                className="sphera-grid"
                style={{
                    height: '100%',
                    width: '100%'
                }}
                data={props.dataResult}
                {...props.dataState}
                onDataStateChange={props.dataStateChange}
                sortable={true}
                reorderable={true}
                resizable={true}
                onColumnReorder={columnReorder}
                onColumnResize={columnResize}
                scrollable="scrollable"
                pageable={{
                    buttonCount: 4,
                    pageSizes: [25, 50, 100]
                }}
            >
                {stateColumns.map(
                    (column, idx) =>
                        column.show && (
                            <Column
                                key={idx}
                                cell={(props2) =>
                                    <TextCell field={column.field}
                                        isLink={column.isLink}
                                        searchedPhrase=""
                                        linkClick={linkClick}
                                        clickId={props2.dataItem.materialId}
                                        DisplayValue={column.AdjustTimezone ? props2.dataItem[column.field + "Display"] : props2.dataItem[column.field]}
                                        customer={props.customer}
                                        isDate={column.isDate}
                                        adjustTimezone={column.AdjustTimezone}
                                    />
                                }
                                field={column.field}
                                title={props.localizations[column.title]}
                                filter={column.filter}
                                format={dateFormat}
                                width={column.width}
                                minResizableWidth={100}
                                headerClassName={GridColumnMenuFilter.active(column.field, props.dataState.filter) ? 'active' : ''}
                                headerCell={(props2) =>
                                    <span className="k-cell-inner">
                                        <span className="k-link" onClick={props2.onClick} onKeyDown={(e) => { if (e.code === "Enter") props2.onClick(); }}>
                                            <SpheraTooltip anchor="target" position="top" title={props.localizations[column.title]} >
                                                <span className="k-column-title">{props.localizations[column.title]}</span>
                                            </SpheraTooltip>
                                            {props2.children}
                                        </span>
                                        <GridColumnMenuWrapper
                                            {...props2.columnMenuWrapperProps}
                                        ></GridColumnMenuWrapper>
                                    </span>
                                }
                                columnMenu={(props2) => (
                                    <CustomColumnMenu {...props2} data={props.historyData} checkboxFilter={column.checkboxFilter} columns={historyGridColumns} useDateFilter={column.isDate} dateFormatFilter={(column.field === "revisionDate") ? shortDateFormatFilter : dateFormatFilter} />
                                )}
                            />
                        )
                )}
            </Grid>
            {props.pending && <LoadingPanel localizations={props.localizations} />}
        </div>
    );
}